<template>
  <div>
    <PageTitle
      text="Minha jornada nos módulos"
      :title-class="titleClassHeader"
      :padding-container-header="paddingContainerHeader"
      :show-border-bottom="showBorderBottomHeader"
    >
      <div
        :class="`${backgroundColorHeader} ${opened ? borderRadiusHeader : 'rounded-lg'} d-flex justify-content-between mb-0 w-100`"
        :style="`border-radius: ${borderRadiusHeader}; padding: ${paddingHeader}; background-color: ${backgroundColorHeader} `"
      >
        <div>
          <slot name="title" />
        </div>
        <a
          href="#"
          @click.prevent=" opened = !opened"
        >
          <i
            class="fas text-gray-400"
            :class="{
              'fa-chevron-circle-down': opened,
              'fa-chevron-circle-up': !opened
            }"
          />
        </a>
      </div>
    </PageTitle>
    <collapse-transition>
      <div
        v-show="opened"
        :class="`${collapseBodyBackground} ${paddingBody}`"
      >
        <slot name="content" />
      </div>
    </collapse-transition>
  </div>
</template>

<script>
import PageTitle from "./PageTitle.vue"
export default {
    components:{
        PageTitle
    },
    props:{
        show:{
          type: Boolean,
          default: true,
        },
        titleClassHeader:{
            type:String,
            required:false,
            default:'h5'
        },
        titleWeightHeader:{
            type:String,
            required:false,
            default:'bolder'
        },
        borderRadiusHeader: {
          type: String,
          required: false,
          default: ''
        },
        paddingHeader: {
          type: String,
          required: false,
          default: ''
      },
        paddingContainerHeader: {
          type: String,
          required: false,
          default: 'p-4'
      },
        backgroundColorHeader: {
          type: String,
          required: false,
          default: ''
      },
      showBorderBottomHeader: {
        type: Boolean,
        required: false,
        default: true
      },
      collapseBodyBackground: {
        type: String,
        required: false,
        default: 'bg-white'
      },
      paddingBody: {
        type: String,
        required: false,
        default: ''
      },
    },
    data(){
      return {
          opened: true
      }
    },
    watch:{
      opened(value){
        this.$emit('input', value)
      }
    },
    mounted(){
      this.opened = this.show
    }
}
</script>
